import { render, staticRenderFns } from "./ExpiredResetPassword.vue?vue&type=template&id=ce0d39a2&"
import script from "./ExpiredResetPassword.vue?vue&type=script&lang=js&"
export * from "./ExpiredResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports